import { ref } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'



export default function useContractEdit(root) {

  const requestStatus = ref(false)
  const errors = ref({})
  const contractData = ref(null)

  const contractorsOptions = ref([])

  store.dispatch('app-contract/fetchContactors', {
    type: 'user',
    user: store.state.auth.userData.id
  }).then(res => contractorsOptions.value = res.data.data)


  const submit = () => {
    requestStatus.value = true
    errors.value = {}
    store.dispatch('app-contract/editContract', contractData.value).then(res => {
      requestStatus.value = false
      toaster('Contract Updated successfully',
        'success', 'Success')

    }).catch(res => {
      errors.value = res.response.data
    }).finally(() => {
      requestStatus.value = false
    })
  }



  const fetchContract = () => {
    requestStatus.value = true
    store.dispatch('app-contract/fetchContract', { id: router.currentRoute.params.id })
      .then(response => {
        contractData.value = response.data.data
        requestStatus.value = false
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 404) {
          contractData.value = undefined
          requestStatus.value = false
        }
      })
  }


  const toaster = (msg, variant = 'success', title = 'success') => {
    root.$bvToast.toast(root.$t(msg), {
      title: root.$t(title),
      variant,
      solid: true,
    })
  }


  return {
    contractorsOptions,
    toaster,
    submit,
    contractData,
    fetchContract,
    requestStatus,
    errors
  }

}
